import React from 'react';
import ReactDOM from 'react-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Brand palette: plain white and green only
const theme = createMuiTheme({
  palette: {
    primary: { main: '#008000', contrastText: '#ffffff' },
    secondary: { main: '#008000', contrastText: '#ffffff' },
    text: { primary: '#0b290b', secondary: '#4a684a' },
    background: { default: '#ffffff', paper: '#ffffff' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    button: { textTransform: 'none', fontWeight: 600 },
  },
  props: {
    MuiButton: { color: 'primary' },
    MuiInput: { color: 'primary' },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// Register service worker to enable offline support and mobile PWA installation
serviceWorker.register();
